import { render } from "./PaiSelect.vue?vue&type=template&id=63bb5cd3&scoped=true"
import script from "./PaiSelect.vue?vue&type=script&lang=js"
export * from "./PaiSelect.vue?vue&type=script&lang=js"

import "./PaiSelect.vue?vue&type=style&index=0&id=63bb5cd3&scoped=true&lang=css"

import exportComponent from "C:\\llx\\1-it\\mahjong-vue-PWA-PR\\mahjong-vue-PWA-PR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bb5cd3"]])

export default __exports__